document.addEventListener("DOMContentLoaded", function () {
  const isClinicOrReviewPage =
     window.location.pathname.includes("pages/traya-clinic-pune") ||
     window.location.pathname.includes("pages/reviews") ||
     window.location.pathname.includes("pages/hair-quiz") ||
     window.location.pathname.includes("pages/root-cause-of-hair-loss") ||
     window.location.pathname.includes("pages/root-cause-of-hair-loss-hindi") ||
     window.location.pathname.includes("pages/hair-quiz-hindi") 

  document
    .querySelectorAll(".faq-question-answer details")
    .forEach((detail) => {
      detail.addEventListener("toggle", function () {
        const icon = this.querySelector(".faq-icon");
        const summary = this.querySelector("summary");

        if (this.open) {
          if (isClinicOrReviewPage) {
            icon.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
                <path d="M5 3.76688L2.17154 6.59538L0.757324 5.18108L5 0.938477L9.2426 5.18108L7.8284 6.59538L5 3.76688Z" fill="#262626"/>
              </svg>`;
            summary.style.marginBottom = "16px";
          } else {
            icon.textContent = "-";
          }
        } else {
          if (isClinicOrReviewPage) {
            icon.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                <path d="M5 5.93908L0.757324 1.69648L2.17154 0.282227L5 3.11068L7.8284 0.282227L9.2426 1.69648L5 5.93908Z" fill="#262626"/>
              </svg>`;
            summary.style.marginBottom = "0";
          } else {
            icon.textContent = "+";
          }
        }
      });
    });
});
